import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Shell } from './Shell';

export function mountShell(kind: 'member' | 'teaching' | 'employer' | 'admin'): void {
    const root = document.getElementById('suac-shell');
    if (!root) throw new Error('SUAC shell mount point is missing.');
    createRoot(root).render(
        <StrictMode>
            <Shell kind={kind} />
        </StrictMode>,
    );
}
